import { Box, Typography } from '@mui/material';
import { GetSessionError } from '~/backend/connector-api/connector-components';
import LabeledContainer from '~/components/LabeledContainer';
import { Image3D } from '~/domain/patient/image3d';
import ImageDataPreview from './ImageDataPreview';

type InputDataDisplayProps = {
    image?: Image3D;
    isLoading?: boolean;
    error?: Error | GetSessionError | null;
};

export default function ImageDataDisplay({
    image,
    isLoading,
    error,
}: InputDataDisplayProps) {
    return (
        <Box display="flex" gap={1}>
            {error ? (
                <Box
                    width="100%"
                    display="flex"
                    alignItems="center"
                    p={2}
                    sx={(theme) => ({
                        borderRadius: `${theme.shape.borderRadius}px`,
                        border: '1px solid red',
                        backgroundColor: 'rgba(255, 0, 0, 0.1)',
                    })}
                >
                    <Typography variant="body2" color="error">
                        Error when trying to load session data.
                    </Typography>
                </Box>
            ) : (
                <LabeledContainer label={'Image'}>
                    <ImageDataPreview image={image} isLoading={isLoading} />
                </LabeledContainer>
            )}
        </Box>
    );
}
